import { Controller } from "@hotwired/stimulus"
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  Tooltip
} from "chart.js"
import { weatherTooltipPlugin } from "./chart_weather_tooltip"

Chart.register(BarController, BarElement, CategoryScale, Legend, LinearScale, Tooltip)

const PX_PER_DAY_2WEEKS = 60

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    standing: Array,
    sitting: Array,
    lying: Array,
    weather: Array,
    period: String
  }

  connect() {
    const weather = this.weatherValue

    if (this.periodValue === "2weeks") {
      this.setupScrollableChart()
    }

    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "立っている",
            data: this.standingValue,
            backgroundColor: "#A8D5BA",
            maxBarThickness: 20
          },
          {
            label: "座っている",
            data: this.sittingValue,
            backgroundColor: "#A8C8E0",
            maxBarThickness: 20
          },
          {
            label: "横になっている",
            data: this.lyingValue,
            backgroundColor: "#E0A8A8",
            maxBarThickness: 20
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: { display: false },
          tooltip: weatherTooltipPlugin(weather, this.labelsValue, (dp) => {
            const val = dp.parsed.y
            if (val === null || val === undefined) return ""
            return `${dp.dataset.label}: ${val}%`
          })
        },
        scales: {
          x: {
            stacked: true,
            grid: { display: false },
            title: {
              display: true,
              text: "(日)",
              font: { size: 10 }
            },
            ticks: {
              font: { size: 10 },
              maxRotation: 0
            }
          },
          y: {
            stacked: true,
            beginAtZero: true,
            max: 100,
            grid: { color: "#ECECEC" },
            ticks: {
              font: { size: 10 },
              callback: (value) => `${value}%`
            }
          }
        }
      }
    })

    if (this.periodValue === "2weeks") {
      this.scrollToEnd()
    }
  }

  setupScrollableChart() {
    const container = this.element
    const existing = container.querySelector("[data-scrollable-wrapper]")
    if (existing) {
      existing.style.width = `${this.labelsValue.length * PX_PER_DAY_2WEEKS}px`
      return
    }
    container.style.overflowX = "auto"
    const wrapper = document.createElement("div")
    wrapper.style.height = "100%"
    wrapper.style.width = `${this.labelsValue.length * PX_PER_DAY_2WEEKS}px`
    wrapper.setAttribute("data-scrollable-wrapper", "")
    container.appendChild(wrapper)
    wrapper.appendChild(this.canvasTarget)
  }

  scrollToEnd() {
    this.element.scrollLeft = this.element.scrollWidth
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
    const wrapper = this.element.querySelector("[data-scrollable-wrapper]")
    if (wrapper) {
      wrapper.remove()
    }
  }
}
